import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/case-study/ai-everything-mea/aie-thumb.png"

export function Index() {
  return (
    <Layout
      title="AI avatar challenge that drove 2,000+ registrations for AI Everything MEA Egypt"
      description="AI Everything MEA Egypt was a first-edition show with a first-edition problem: not enough people knew about it yet. With two weeks to go, the team partnered with Premagic to launch the AIE Avatar Challenge"
      metaImage={ThumbnailImage}
    >
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.AI_EVERYTHING_MEA} />
    </Layout>
  )
}

export default Index
